export const SECTOR_OPTIONS = [
  {
    label: 'Energy',
    value: 'Energy'
  },
  {
    label: 'Materials',
    value: 'Materials'
  },
  {
    label: 'Industrials',
    value: 'Industrials'
  },
  {
    label: 'Consumer Discretionary',
    value: 'Consumer Discretionary'
  },
  {
    label: 'Consumer Staples',
    value: 'Consumer Staples'
  },
  {
    label: 'Health Care',
    value: 'Health Care'
  },
  {
    label: 'Financials',
    value: 'Financials'
  },
  {
    label: 'Information Technology',
    value: 'Information Technology'
  },
  {
    label: 'Communication Services',
    value: 'Communication Services'
  },
  {
    label: 'Utilities',
    value: 'Utilities'
  },
  {
    label: 'Real Estate',
    value: 'Real Estate'
  }
]
